import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
const buyers: {
  name: string;
  city: string;
}[] = [{
  name: 'Mariana G.',
  city: 'Buenos Aires'
}, {
  name: 'Laura P.',
  city: 'Córdoba'
}, {
  name: 'Daniela R.',
  city: 'Rosario'
}, {
  name: 'Sofía M.',
  city: 'Mendoza'
}, {
  name: 'Paula C.',
  city: 'La Plata'
}, {
  name: 'Romina T.',
  city: 'Mar del Plata'
}, {
  name: 'Carolina V.',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Florencia A.',
  city: 'Salta'
}, {
  name: 'Valentina L.',
  city: 'Santa Fe'
}, {
  name: 'Gabriela S.',
  city: 'Neuquén'
}, {
  name: 'Lucía B.',
  city: 'Bahía Blanca'
}, {
  name: 'Andrea M.',
  city: 'San Juan'
}, {
  name: 'Verónica D.',
  city: 'Resistencia'
}, {
  name: 'Natalia F.',
  city: 'Posadas'
}, {
  name: 'Cecilia R.',
  city: 'Paraná'
}, {
  name: 'Belén O.',
  city: 'San Salvador de Jujuy'
}];
const avatarColors = ['bg-pastel-blue', 'bg-pastel-mint', 'bg-pastel-yellow', 'bg-pastel-lilac', 'bg-pastel-coral'];
type Notification = {
  id: number;
  name: string;
  city: string;
  minutesAgo: number;
  color: string;
};
function randomBetween(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function PurchasePopup() {
  const [current, setCurrent] = useState<Notification | null>(null);
  const showNotification = useCallback(() => {
    const buyer = buyers[Math.floor(Math.random() * buyers.length)];
    const color = avatarColors[Math.floor(Math.random() * avatarColors.length)];
    setCurrent({
      id: Date.now(),
      name: buyer.name,
      city: buyer.city,
      minutesAgo: randomBetween(2, 25),
      color
    });
    // Auto-hide after 6 seconds
    window.setTimeout(() => {
      setCurrent(null);
    }, 6000);
  }, []);
  useEffect(() => {
    let interval: number;
    // First popup after a short initial delay
    const initialDelay = window.setTimeout(() => {
      showNotification();
      const loop = () => {
        // Every 40-60 seconds
        interval = window.setTimeout(() => {
          showNotification();
          loop();
        }, randomBetween(40000, 60000));
      };
      loop();
    }, 8000);
    return () => {
      window.clearTimeout(initialDelay);
      window.clearTimeout(interval);
    };
  }, [showNotification]);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-218">
      <AnimatePresence data-id="element-219">
        {current && <motion.div key={current.id} initial={{
        opacity: 0,
        x: -40,
        y: 20
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 24
      }} className="pointer-events-auto bg-white rounded-2xl shadow-soft border border-slate-100 p-4 pr-10 flex items-center gap-3 max-w-[20rem] relative" role="status" aria-live="polite" data-id="element-220">
            <button onClick={() => setCurrent(null)} className="absolute top-2 right-2 text-slate-300 hover:text-slate-500 transition-colors" aria-label="Cerrar notificación" data-id="element-221">
              <X className="w-4 h-4" data-id="element-222" />
            </button>

            <div className={`w-11 h-11 rounded-full ${current.color} flex items-center justify-center text-slate-800 font-bold shrink-0`} data-id="element-223">
              {current.name.charAt(0)}
            </div>

            <div className="min-w-0" data-id="element-224">
              <div className="flex items-center gap-1 text-pastel-mint mb-0.5" data-id="element-225">
                <BadgeCheck className="w-4 h-4 text-emerald-500" data-id="element-226" />
                <span className="text-xs font-bold text-emerald-600 uppercase tracking-wide" data-id="element-227">
                  Compra verificada
                </span>
              </div>
              <p className="text-sm font-bold text-slate-800 leading-tight truncate" data-id="element-228">
                {current.name}{' '}
                <span className="font-medium text-slate-500" data-id="element-229">
                  de {current.city}
                </span>
              </p>
              <p className="text-xs text-slate-500 leading-tight" data-id="element-230">
                compró{' '}
                <span className="font-semibold" data-id="element-231">Método Escribo Jugando</span> ·
                hace {current.minutesAgo} min
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}